// 错误码
export const errorMsg = {
  serverError: {
    code: 500,
    msg: $t('message_1'),
  },
  argsError: {
    code: 1001,
    msg: $t('message_2'),
  },
  recordNotFoundError: {
    code: 1002,
    msg: $t('message_3'),
  },
  recordAlreadyExistError: {
    code: 1003,
    msg: $t('message_4'),
  },
  accessDeniedError: {
    code: 1004,
    msg: $t('message_5'),
    errorToken: true,
  },
  tokenUnknownError: {
    code: 1100,
    msg: $t('message_6'),
    errorToken: true,
  },
  tokenNotExistError: {
    code: 1101,
    msg: $t('message_6'),
    errorToken: true,
  },
  tokenExpiredError: {
    code: 1102,
    msg: $t('message_7'),
    errorToken: true,
  },
  tokenInvalidError: {
    code: 1103,
    msg: $t('message_8'),
    errorToken: true,
  },
  tokenNotMatchError: {
    code: 1104,
    msg: $t('message_9'),
    errorToken: true,
  },
  tokenNotValidYetError: {
    code: 1105,
    msg: $t('message_10'),
    errorToken: true,
  },
  alreadyRegisteredError: {
    code: 1200,
    msg: $t('message_11'),
  },
  accountNotFoundError: {
    code: 1201,
    msg: $t('message_12'),
  },
  passwordError: {
    code: 1202,
    msg: $t('message_13'),
  },
  permissionIdNotFoundError: {
    code: 1300,
    msg: $t('message_14'),
  },
  notPermissionError: {
    code: 1301,
    msg: $t('message_15'),
  },
  roleIdNotFoundError: {
    code: 1302,
    msg: $t('message_16'),
  },
  accountIsBlockedError: {
    code: 1203,
    msg: $t('message_17'),
  },
  UserIDNotFoundError: {
    code: 1204,
    msg: $t('message_18'),
  },
} as const;

/**
 * 获取错误码
 * @param code
 */
export const getErrorMsg = (code: number) => {
  for (const key in errorMsg) {
    if (Object.prototype.hasOwnProperty.call(errorMsg, key)) {
      const item = errorMsg[key];
      if (item.code === code) {
        return item;
      }
    }
  }
};
